import { Alert, Snackbar } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

import { RootState } from 'src/store/store';
import { clearNotifier } from 'src/store/reducers/notifierReducer';

const Notifier: React.FC = () => {
    const [isOpen, setOpen] = useState(false);

    const dispatch = useDispatch();
    const { message, type } = useSelector((state: RootState) => state.notifier);

    useEffect(() => {
        if (message) {
            setOpen(true);
            setTimeout(() => {
                dispatch(clearNotifier());
            }, 4000);
        }
    }, [message, dispatch]);

    return message ? (
        <Snackbar
            anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
            autoHideDuration={3000}
            onClose={() => setOpen(false)}
            open={isOpen}
        >
            <Alert onClose={() => setOpen(false)} severity={type} sx={{ width: '100%' }} variant="filled">
                {message}
            </Alert>
        </Snackbar>
    ) : (
        <></>
    );
};

export default Notifier;
